function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoImageOverlay = require('./../../../lib/saito/ui/saito-image-overlay/saito-image-overlay');
var RedSquareImageTemplate = require('./image.template');
var RedSquareImage = /*#__PURE__*/function () {
  function RedSquareImage(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var images = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var sig = arguments.length > 4 ? arguments[4] : undefined;
    _classCallCheck(this, RedSquareImage);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.images = images;
    this.sig = sig;
    this.overlay = new SaitoImageOverlay(app, mod, images);
  }
  return _createClass(RedSquareImage, [{
    key: "render",
    value: function render() {
      var element = this.container + ' > .tweet-image ';
      var template = RedSquareImageTemplate(this.app, this.mod, this.images);
      var sig = this.sig;
      var expected_width = 520;
      var expected_height = 'auto';

      //
      // avoid length vertical posts
      //

      for (var i = 0; i < this.images.length; i++) {
        var img = new Image();
        /*
           img.onload = function () {
             let available_width_qs = ".tweet-" + sig + " > .tweet-body";
             if (document.querySelector(available_width_qs)) {
               let obj = document.querySelector(available_width_qs);
               expected_width = parseInt(obj.getBoundingClientRect().width);
             }
              let aspect_ratio = img.width / img.height;
             
             if (img.height >= img.width) {
               expected_height = expected_width;
             } else {
               expected_height = expected_width / aspect_ratio;
             }
              let qs = ".tweet-" + sig + " > .tweet-body  .tweet-image .image-" + i;
             let obj = document.querySelector(qs);
             if (obj) {
               obj.style.maxHeight = Math.floor(expected_height) + "px";
               obj.style.maxWidth = expected_width + "px";
             }
           };
           */
        img.src = this.images[i];
      }
      if (document.querySelector(element)) {
        this.app.browser.replaceElementBySelector(template, element);
      } else {
        if (this.container) {
          this.app.browser.addElementToSelector(template, this.container);
        } else {
          this.app.browser.addElementToDom(template);
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var sel = '.tweet-' + this.sig + ' > .tweet-body .tweet-image img';
      if (document.querySelector(sel)) {
        document.querySelectorAll(sel).forEach(function (image) {
          image.onclick = function (e) {
            if (image.naturalHeight > image.height || image.naturalWidth > image.width) {
              var image_idx = e.currentTarget.getAttribute('data-index');
              _this.overlay.render(image_idx);
            } else {
              console.warn('Img small, no preview', "".concat(image.width, "x").concat(image.height, " versus ").concat(image.naturalWidth, "x").concat(image.naturalHeight));
            }
          };
        });
      } else {
        console.warn('No image selected!!!');
      }
    }
  }]);
}();
module.exports = RedSquareImage;